// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Target_target__lUyhv {
  margin-top: 40px;
  display: grid;
  grid-template-columns: 5fr 3fr;
  gap: 20px;
}
@media (max-width: 680px) {
  .Target_target__lUyhv {
    grid-template-columns: 1fr;
  }
}
.Target_target__lUyhv .Target_left__8GyUQ {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.Target_target__lUyhv .Target_left__8GyUQ p {
  margin-top: 70px;
}
@media (max-width: 680px) {
  .Target_target__lUyhv .Target_left__8GyUQ p {
    margin-top: 25px;
  }
}
.Target_target__lUyhv .Target_left__8GyUQ p strong {
  color: var(--red);
  font-size: 1.5rem;
  font-weight: 400;
  font-family: "Rubik Glitch";
}
.Target_target__lUyhv .Target_left__8GyUQ img {
  max-width: 100%;
}
@media (max-width: 1060px) {
  .Target_target__lUyhv .Target_left__8GyUQ img {
    max-width: 115%;
    margin-right: -10%;
  }
}
@media (max-width: 680px) {
  .Target_target__lUyhv .Target_left__8GyUQ img {
    max-width: 115%;
    margin-right: -7%;
  }
}
.Target_target__lUyhv .Target_right__a3FoE {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 50px;
}
@media (max-width: 680px) {
  .Target_target__lUyhv .Target_right__a3FoE {
    transform: scaleX(-1) translateX(50px);
  }
}
.Target_target__lUyhv .Target_right__a3FoE img {
  width: 90%;
}
.Target_target__lUyhv .Target_right__a3FoE .Target_foto1__h-QgD, .Target_target__lUyhv .Target_right__a3FoE .Target_foto3__Hu-UB {
  margin-left: -100px;
}
@media (max-width: 680px) {
  .Target_target__lUyhv .Target_right__a3FoE .Target_foto1__h-QgD, .Target_target__lUyhv .Target_right__a3FoE .Target_foto3__Hu-UB {
    margin-top: -70px;
    margin-left: -100px;
    align-self: flex-start;
  }
}
.Target_target__lUyhv .Target_right__a3FoE .Target_foto2__F4iK3 {
  margin: -100px 0;
}
@media (max-width: 680px) {
  .Target_target__lUyhv .Target_right__a3FoE .Target_foto2__F4iK3 {
    align-self: flex-end;
    margin: -50% 0;
    margin-right: -20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Target/Target.module.scss"],"names":[],"mappings":"AAEA;EACG,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AADH;AAGG;EANH;IAOM,0BAAA;EAAJ;AACF;AAEG;EACG,aAAA;EACA,sBAAA;EACA,qBAAA;AAAN;AAEM;EACG,gBAAA;AAAT;AAES;EAHH;IAIM,gBAAA;EACV;AACF;AAES;EACG,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;AAAZ;AAGM;EACG,eAAA;AADT;AAGS;EAHH;IAIM,eAAA;IACA,kBAAA;EAAV;AACF;AAES;EARH;IASM,eAAA;IACA,iBAAA;EACV;AACF;AAGG;EACG,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AADN;AAGM;EATH;IAUM,sCAAA;EAAP;AACF;AAEM;EACG,UAAA;AAAT;AAGM;EACG,mBAAA;AADT;AAGS;EAHH;IAIM,iBAAA;IACA,mBAAA;IACA,sBAAA;EAAV;AACF;AAGM;EACG,gBAAA;AADT;AAIS;EAJH;IAKM,oBAAA;IACA,cAAA;IACA,mBAAA;EADV;AACF","sourcesContent":["\n\n.target{\n   margin-top: 40px;\n   display: grid;\n   grid-template-columns: 5fr 3fr;\n   gap: 20px;\n\n   @media (max-width: 680px) {\n      grid-template-columns: 1fr;\n   }\n\n   .left{\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n\n      p{\n         margin-top: 70px;\n\n         @media (max-width: 680px) {\n            margin-top: 25px;\n         }\n      \n\n         strong{\n            color: var(--red);\n            font-size: 1.5rem;\n            font-weight: 400;\n            font-family: 'Rubik Glitch'; \n         }\n      }\n      img{\n         max-width: 100%;\n\n         @media (max-width: 1060px) {\n            max-width: 115%;\n            margin-right: -10%;\n         }\n\n         @media (max-width: 680px) {\n            max-width: 115%;\n            margin-right: -7%;\n         }\n      }\n   }\n\n   .right{\n      height: 100%;\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      padding-left: 50px;\n\n      @media (max-width: 680px) {\n         transform: scaleX(-1) translateX(50px);\n      }\n\n      img{\n         width: 90%;\n      }\n\n      .foto1, .foto3{\n         margin-left: -100px;\n\n         @media (max-width: 680px) {\n            margin-top: -70px;\n            margin-left: -100px;\n            align-self: flex-start;\n         }\n      }\n\n      .foto2{\n         margin: -100px 0;\n         \n\n         @media (max-width: 680px) {\n            align-self: flex-end;\n            margin: -50% 0;\n            margin-right: -20px;\n         }\n      }\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"target": `Target_target__lUyhv`,
	"left": `Target_left__8GyUQ`,
	"right": `Target_right__a3FoE`,
	"foto1": `Target_foto1__h-QgD`,
	"foto3": `Target_foto3__Hu-UB`,
	"foto2": `Target_foto2__F4iK3`
};
export default ___CSS_LOADER_EXPORT___;
